try {
    if ($('#pagenotfound').length > 0 || ($('#search').length > 0)) {
        $('#search-not-found-page').focus();
    }
} catch (error) {
    console.log(error);
}